import { MenuItem, FormControl, Box } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { DropdownProps } from "./interface";
import Typography from "@atoms/Typography";
import useStyles from "./styles";
import InputBase from "../InputBase";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const Dropdown = (props: DropdownProps) => {
  const {
    onChange,
    placeholder,
    value,
    options,
    helperText,
    label,
    width,
    error,
    disabled,
    optional,
    multiple,
  } = props;

  const classes = useStyles();

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as string);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _renderValue = (selected: any) => {
    if (selected.length === 0) {
      return <Typography variant="body1" color="general-light" font="nunito">{placeholder}</Typography>;
    }

    let value;

    if (Array.isArray(selected)) {
      value = options.filter((item) => selected.includes(item.value)).map((item) => item.label);
      return <Typography variant="body1" font="nunito">{value.reduce((prev, curr) => [prev, ', ', curr])}</Typography>;
    }

    value = options.find((item) => item.value === selected)?.label;
    return <Typography variant="body1" font="nunito">{value}</Typography>;
  };

  return (
    <FormControl sx={{ width }}>
      {(label || optional) && (
        <Box sx={{ mb: 0.5 }} display="flex">
          <Typography variant="subtitle1" weight="medium">{label}</Typography>&nbsp;
          {optional && <Typography variant="caption" color="general-mid" className={classes.optional}>(optional)</Typography>}
        </Box>
      )}
      <Select
        displayEmpty
        value={value}
        onChange={handleChange}
        IconComponent={KeyboardArrowDownRoundedIcon}
        multiple={multiple}
        sx={{ mb: helperText ? 1 : 0 }}
        disabled={disabled}
        error={error}
        classes={{
          select: classes.select,
        }}
        MenuProps={MenuProps}
        renderValue={_renderValue}
        input={<InputBase />}
      >
        {options.map((item, idx) => (
          <MenuItem key={idx} value={item.value}>{item.label}</MenuItem>
        ))}
      </Select>
      <Typography variant="caption" color={error ? "primary-main" : "general-main"}>{helperText}</Typography>
    </FormControl>
  );
};

export default Dropdown;
